package it.neckar.lizergy.model.financial.quote

import it.neckar.financial.currency.sum
import it.neckar.lizergy.model.financial.currency.Money
import it.neckar.lizergy.model.financial.currency.PriceWithProfit
import it.neckar.lizergy.model.financial.currency.sum
import it.neckar.open.collections.fastMap
import it.neckar.open.unit.currency.EUR

fun List<QuoteItem>.net(): @EUR Money {
  return fastMap { it.netPrice }.sum()
}

fun List<QuoteItem>.gross(): @EUR Money {
  return fastMap { it.grossPrice }.sum()
}

fun List<QuoteItem>.priceWithProfit(): PriceWithProfit {
  return fastMap { it.priceWithProfit }.sum()
}
